export const JOB_CATEGORIES_ARRAY =
    ['Administración y finanzas',
        'Comunicación y Marketing',
        'Cooperación',
        'Dirección y coordinación',
        'Gestión de proyectos',
        'Legal',
        'Diseño',
        'Arquitectura',
        'Ciencias de la salud',
        'Recursos humanos',
        'Imagen y sonido',
        'Tecnologías de la información(IT)',
        'Traducción e interpretación'
    ]


